import { render } from "./print-debtor-receipt.vue?vue&type=template&id=868b2588&scoped=true"
import script from "./print-debtor-receipt.vue?vue&type=script&lang=js"
export * from "./print-debtor-receipt.vue?vue&type=script&lang=js"

import "./print-debtor-receipt.vue?vue&type=style&index=0&id=868b2588&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868b2588"]])

export default __exports__